import { InventorySourcePreference } from 'src/app/core/infrastructure/enums/inventory-source-preference.enum';

export enum AdRecommendAction {
  NONE = 'NONE',
  PAUSE = 'PAUSE',
  ENABLE = 'ENABLE',
}

export interface AdRecommendationDisplay {
  title: string;
  message: string;
  icon: string;
  alertClass: string;
  action: AdRecommendAction;
}

export interface InventoryRow {
  field?: string;
  label: string;
  value: number;
  source?: InventorySourcePreference | string;
  info?: string;
  hidden?: boolean;
  isTotalRow?: boolean;
}

/**
 * Default rows for Section 1: Inventory Available
 */
export const INVENTORY_ROWS: InventoryRow[] = [
  { field: 'onHand', label: 'On Hand FBA', value: 0, source: InventorySourcePreference.FBA },
  { field: 'onHandFbm', label: 'On Hand FBM', value: 0, source: InventorySourcePreference.FBM },
  { field: 'awdInventoryQty', label: 'AWD', value: 0 },
  { field: 'inboundReceiving', label: 'Inbound', value: 0 },
  { field: 'inventoryAvailable', label: 'Total', value: 0 },
];

/**
 * Recommendation matrix (health x ad-status):
 *
 *   active  + at-risk   → PAUSE   (health-colored alert)
 *   active  + well      → NONE    (neutral — already running)
 *   paused  + at-risk   → NONE    (neutral — already safe)
 *   paused  + well      → ENABLE  (green alert)
 */
export const AD_RECOMMENDATIONS = {
  PAUSE: <AdRecommendationDisplay>{
    title: 'Recommended: Pause SKU',
    message: 'This SKU is at risk for advertising. We recommend pausing SKU until stock is replenished.',
    icon: 'icon-pause',
    alertClass: 'alert-oos',
    action: AdRecommendAction.PAUSE,
  },
  ENABLE: <AdRecommendationDisplay>{
    title: 'Recommended: Enable SKU',
    message: 'This SKU is well-stocked and ready for active advertising. Enabling SKUs will maximize sales velocity and revenue potential.',
    icon: 'icon-play',
    alertClass: 'alert-well',
    action: AdRecommendAction.ENABLE,
  },
  NONE_PAUSED: <AdRecommendationDisplay>{
    title: 'Recommended: None',
    message: 'Do not worry! This SKU is {status} but already paused.',
    icon: 'icon-square',
    alertClass: 'alert-none',
    action: AdRecommendAction.NONE,
  },
  NONE_ACTIVE: <AdRecommendationDisplay>{
    title: 'Recommended: None',
    message: 'Looking good! This SKU is well-stocked and running in advertisement.',
    icon: 'icon-square',
    alertClass: 'alert-none',
    action: AdRecommendAction.NONE,
  },
};